import { NavList } from '@deckee/deck-hand';
import styled, { css } from 'styled-components';
import { IconWithTextLockupProps } from '../../../../lockups/IconWithTextLockup/IconWithTextLockup';

type SafetyGearFilterBlockProps = IconWithTextLockupProps & { error?: boolean };

const StyledNavListItem = styled(NavList.Item)<SafetyGearFilterBlockProps>`
  text-decoration: none;
  > * {
    overflow: visible;
  }
  /* No idea why this is required - having trouble removing the browser link styles ;() */
  :-webkit-any-link {
    color: inherit;
  }
  ${({ error, theme }) =>
    error &&
    css`
      padding-left: 4px;
      margin-left: -4px;
      border: 2px solid ${theme.colors.danger};
      border-radius: 5px;
    `}
`;

export default StyledNavListItem;
